define('drops/hotspot/hotspot',[
    'jquery',
    'lq/drop',
    'lq/style',
    'drops/magicWand/magicWand',
    'underscore'
], function ($, Drop, Style, MagicWand, _) {
    'use strict';

    var selections = [];
    var selectionClickedEvent = 'selectionClicked'

    function Hotspot(options) {
        Drop.call(this, $('<div />'), null, options);

        this.$image = $('<img />')
            .css({
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .appendTo(this.$element);

        this.$canvas = $('<canvas />')
            .css({
                'position': 'absolute',
                'top': '0px',
                'left': '0px',
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .appendTo(this.$element);

        Style.renderStyles(this, null, this.$image);

        this.hideWhenNecessary();
        this.applyEventTrigger('mouseEnter', 'mouseenter');
    };

    Drop.extend(Hotspot, MagicWand);

    Hotspot.typeName = 'Hotspot';

    Hotspot.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();

        var self = this;
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) { self._update(data);
        });

        this.addEventHandlers();
    }

    Hotspot.prototype._update = function (data) {
        var self = this;
        $.each(data.Results, function (key, result) {
            selections.push(result);
            self.drawBorderFromSimplifiedData(JSON.parse(result[self.data.selectedColumn || 'Path']));
        });
    };

    Hotspot.prototype.addEventHandlers = function () {
        if (this.isEventEnabled(selectionClickedEvent)) {
            this.$canvas.css({ 'cursor': 'pointer' });
            var self = this;
            this.$canvas.on('click', function (e) {
                var position = self.getMousePosition(e);
                var ctx = self.$canvas.get(0).getContext("2d");
                ctx.clearRect(0, 0, self.$image.get(0).width, self.$image.get(0).height);

                _.each(selections, function (selection) {
                    var cs = JSON.parse(selection.Mask);
                    if (cs.inner) { return; }
                    for (var i = 0; i < cs.length; i++) {
                        ctx.beginPath();
                        var color = cs[i].inner ? 'red' : 'blue';
                        self.drawArea(ctx, cs[i].points, color);

                        if (ctx.isPointInPath(position.x, position.y)) {
                            ctx.fillStyle = 'red';
                            ctx.fill();
                            self.triggerEvent(self.data.eventing[selectionClickedEvent].raisedEventName, selection[self.data.eventArg || 'Id']);
                            return;
                        }
                    }
                });
            });
        }
    }

    return Hotspot;
});
